var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle5C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Woman_x5F_hairstyles:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35__3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M436.3,107.8c10.9-0.1,21.8,1.5,32.3,4.1c-2.9-4.3-6.2-8.3-9.7-12c-0.7-0.7-1.3-1.4-2-2.1 c-32.2-33.8-94.8-36.6-125.5-0.1l0,0c-1.1-0.3-2.1-0.5-3.2-0.7c-26.2-5.5-53.2,3.2-73.6,20.2c-4.6,3.8-8.9,8.1-12.7,12.6 c-26.7,27.9-26.2,69.3-8.2,100.4c3.5,6,7.6,11.6,12.3,16.7c1.4,1.6,2.9,3.1,4.5,4.5c1,0,2,0.2,2.9,0.4c2,0.5,3.7,1.5,5.3,2.8 c3.5,3,5.9,7.6,8.1,12.1c0-1.6,0-3.2,0-4.8c0.7-28.9,10.4-70.3,43-84.2c1.5-0.6,3.1-1.2,4.7-1.7c-3.2,4.5-8.8,11.3-14.3,12.4 c11.9,2.7,32.8-4.1,41.7-14c16.9,28.9,44.9,40.8,63,44c-0.4-1-0.8-2.1-1.1-3.1c-4.3-12.5-5.2-25.6-4.7-37.7 c13.6,15.6,24.8,33.1,30.6,53.1c0.7-4.3,1.2-8.7,1.4-13.1c0.4-8.4-0.2-16.9-1.9-25.2c15.9,45,5.8,97.3-20.5,137 c6.1-1.3,11.9-3.2,17.3-5.7c1.6-0.8,3.3-1.6,4.8-2.4c9.9-5.4,18.5-12.8,25.7-21.5c5-6.3,9.2-13.1,12.6-20.1 c0.2,8.1-0.6,17.6-2.8,24.2c6.7-4.6,12.9-10.2,18.3-16.7c14.1-16.8,22.2-39.2,15.8-65.3c4.5,5,7.6,10.7,9.8,16.7 c0.2-1,0.3-2,0.5-3C516.1,184.7,492.1,115.1,436.3,107.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M255.2,196.4c-1.6,9.1-1.9,18-0.7,25.9c2.5-24,16.1-46.8,34.3-62.3c11.6-9.5,26.4-14.8,41.2-16.6 c-0.4-1.7-0.7-3.5-1-5.3C294.6,138.1,266,164.9,255.2,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M406.4,88.8c-13.9-1.3-26.8-2.7-41,2.8c-12.1,5-20,14-25.5,24.8c9.8-11.5,18.7-18.1,29.7-22.4 C382.6,89.2,391.7,89.2,406.4,88.8L406.4,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M475.7,148.1c-13.3-14.7-28.1-24.1-46.6-28c17.4,6.7,31.1,16.7,43.5,30.7c13.9,16.7,21.7,33.3,29.4,54.2 l0,0C498.2,183.9,490.5,165.6,475.7,148.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M247.3,164.2c-16.9,16.9-16.6,46.5-13.7,66c3.5,6,7.6,11.6,12.3,16.7 C237.1,225.8,231.7,186.5,247.3,164.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M266.7,262c0.7-28.9,10.4-70.3,43-84.2C275.4,183.5,253.8,228.5,266.7,262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M458.9,99.9c-20.5,0.8-41.4,3-57.1,15.9c10.8-5.6,22.6-7.9,34.5-8.1c10.9-0.1,21.8,1.5,32.3,4.1 C465.7,107.6,462.4,103.6,458.9,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M331.4,97.7C331.3,97.7,331.3,97.7,331.4,97.7C331.3,97.7,331.4,97.7,331.4,97.7L331.4,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M254.4,222.2c-1.2-7.9-0.9-16.8,0.7-25.9c3.4-19.6,12.4-39.9,23.5-52.1c-30,26.8-41,70.3-25.4,107.6 c2,0.5,3.7,1.5,5.3,2.8C254.5,244.1,253.3,233,254.4,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M471.3,181c13.1,31.7,12.8,68.1-2.3,98.9c0.2,8.1-0.6,17.6-2.8,24.2c6.7-4.6,12.9-10.2,18.3-16.7 C496.5,253,490,212.5,471.3,181z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M403.6,215.4c-48.2-16.1-72.4-69.4-72.3-117.7l0,0c-1.1-0.3-2.1-0.5-3.2-0.7 c-1.6,15.5-1.1,29.1,0.8,41.1c0.3,1.8,0.6,3.6,1,5.3c2.5,12.1,6.6,22.4,11.8,31.1c16.9,28.9,44.9,40.8,63,44 C404.3,217.5,404,216.5,403.6,215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M353.1,135.5c15.8,12.7,32.1,26.5,45.8,42.3c13.6,15.6,24.8,33.1,30.6,53.1c0.7-4.3,1.2-8.7,1.4-13.1 C415.8,182.1,387,153.9,353.1,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M434.5,305c16.7-45.1,14-99.1-14.2-138.1c4.1,8.1,7,16.8,8.7,25.7c15.9,45,5.8,97.3-20.5,137 c6.1-1.3,11.9-3.2,17.3-5.7c0.4-0.8,0.9-1.6,1.3-2.4C429.9,316.2,432.4,310.7,434.5,305z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle5C);
export default __webpack_public_path__ + "static/media/woman_hairstyle_5c.a434065df5455f2fb19c3b1e110628b9.svg";
export { ForwardRef as ReactComponent };